import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type AccessoriesCategoriesClasses = 'container';

const accessoriesCategoriesStyles = makeStyles<ISpcTheme, AccessoriesCategoriesClasses>(
  theme => ({
    container: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.text.disabled}`,
    },
  }),
  { name: 'Customise_AccessoriesCategories' },
);

export default accessoriesCategoriesStyles;
